module.exports = __webpack_public_path__ + "img/imgCYYQ(1).fe99b7b9.png";